import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Studies() { 
  useEffect(() => {
    document.title = 'Studies -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Academics</li>
                <li>Studies</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Studies</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <p>The syllabus followed is that of the Anglo Indian schools. The
               Students are prepared for th ICSE Class X and ISC Class XII
               Examination. The curriculum includes English, Hindi, Sanskrit,
               History, Geography, Civics, Maths, General Science, Computer,
               Physical Education and General Knowledge.</p>      
               <p>Co-Curricular activities form an important part of the school
               curriculum and every child is expected to take part in the social and
               cultural activities of the school.</p>
               <p>Students must learn to play and work together. Team spirit is
               necessary and healthy in all spheres of school life.</p>
               </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Studies;
